import { ceil } from "es-toolkit/compat";
import { TIERED_PRODUCTS, TieredPriceProductId } from "./prices.js";
import { round } from "es-toolkit";
/**
 * Sum usage events values
 */
export function sumUsage(usageEvents) {
    let total = 0;
    for (const event of usageEvents) {
        total += event[1];
    }
    return total;
}
/**
 * We charge user per every unit started.
 * For example if user did 1100 requests we calc this as ceil(1100/1000) == 2 units of usage
 */
export function getMeterValue(priceConf, total) {
    const { unitSize, } = priceConf;
    return ceil(total / unitSize);
}
/**
 * This is useful for displaying or calculating above limit usage
 * For example user used 1.1GB storage and free tier is 1GB we want to display 1.1GB not 2 in error message
 */
export function getMeterValuePartial(priceConf, total) {
    const { unitSize, } = priceConf;
    return round(total / unitSize, 3);
}
function calculateUsageCostInner(totalUsage, productId) {
    if (!productId) {
        return 0;
    }
    const config = TIERED_PRODUCTS[productId];
    const meteredUsage = getMeterValue(config, totalUsage);
    const nonFreeUsage = meteredUsage - config.freeTierAllowance;
    if (nonFreeUsage <= 0) {
        return 0;
    }
    const numPrice = Number(config.price);
    return round((nonFreeUsage * numPrice) / 100, 2);
}
export const calculateUsageCost = (usageEvents, productId) => calculateUsageCostInner(Array.isArray(usageEvents) ? sumUsage(usageEvents) : usageEvents, productId);
/**
 * @param allowanceMultiplier number of months / number of "per" units (defaults to 1, correct for per month).
 */
export function calculateCostPerInterval(usageEvents, productId, allowanceMultiplier = 1) {
    const config = TIERED_PRODUCTS[productId];
    const perAllowance = config.freeTierAllowance * allowanceMultiplier;
    return usageEvents.map(([t, usage]) => {
        const nonFreeUsage = getMeterValue(config, usage) - perAllowance;
        return [t, nonFreeUsage > 0 ? round(nonFreeUsage * Number(config.price) / 100, 2) : 0];
    });
}
export const getStorageProductId = (productIds) => {
    return productIds.find(p => p === TieredPriceProductId.TieredStorage);
};
export const getMapSessionProductId = (productIds) => {
    return productIds.find(p => p === TieredPriceProductId.TieredMapSession);
};
export const getTileUsageProductId = (productIds) => {
    return productIds.find(p => p === TieredPriceProductId.TieredTileUsage);
};
export const getProcessingProductId = (productIds) => {
    return productIds.find(p => p === TieredPriceProductId.TieredProcessing);
};
export const getInputTokenProductId = (productIds) => {
    return productIds.find(p => p === TieredPriceProductId.TieredInputToken);
};
export const getOutputTokenProductId = (productIds) => {
    return productIds.find(p => p === TieredPriceProductId.TieredOutputToken);
};
export const getAccountUserProductId = (productIds) => {
    return productIds.find(p => p === TieredPriceProductId.TieredAccountUser);
};
export const getCustomStyleProductId = (productIds) => {
    return productIds.find(p => p === TieredPriceProductId.TieredCustomStyle);
};
export const getCustomTilesetProductId = (productIds) => {
    return productIds.find(p => p === TieredPriceProductId.TieredCustomTileset);
};
//# sourceMappingURL=usage.js.map